import * as buttons from 'smg/buttons';
import * as contact from 'smg/customer-api/contact';
import { ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import * as uploads from 'smg/uploads';
import { Relref } from '../hugo';

main();

function main() {
    const reason = document.querySelector('#reason') as HTMLSelectElement;
    const firstName = document.querySelector('#first-name') as HTMLInputElement;
    const lastName = document.querySelector('#last-name') as HTMLInputElement;
    const company = document.querySelector('#company') as HTMLInputElement;
    const email = document.querySelector('#email') as HTMLInputElement;
    const notes = document.querySelector('#notes') as HTMLTextAreaElement;
    const phone = document.querySelector('#phone') as HTMLInputElement;
    const form = document.querySelector('#form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const header = document.querySelector('h1') as HTMLElement;
    const uploadsLabel = form.querySelector('#uploads') as HTMLLabelElement;
    const $smsOptIn = document.querySelector('#sms-opt-in') as HTMLInputElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const showAlert = (type: 'generic' = 'generic') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        header.after(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    const p = new Phone(phone);

    const u = new uploads.Uploader(uploadsLabel, {
        confirmBtn: confirm,
        thumbnails: document.querySelector('#uploads-thumbnails') as HTMLElement,
    });

    form.noValidate = true;
    form?.addEventListener('submit', e => {
        e.preventDefault();

        if (!ReportValidity(form)) {
            return false;
        }

        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);

        contact.CreateContact({
            name: `${firstName.value} ${lastName.value}`,
            company: company.value,
            email: email.value,
            phone: p,
            content: `Notes: ${notes.value}\nReason: ${reason.value}`,
            uploader: u,
            preferSMS: $smsOptIn.checked || undefined,
            $reCaptchaPlaceholder: form.querySelector('.contact-recpatcha-parent') as HTMLElement,
        }).then(() => {
            window.location.href = Relref('/contact/success');
        }).catch(err => {
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);

            if (err !== contact.ReCaptchaError) {
                showAlert();
            }

            throw err;
        });
    });
}